import React, { useCallback, useRef, useState } from 'react'
import SideMenu from './SideMenu';
import AlertContextWithProvider from '../contexts/alert';
import { useResizeObserver } from '../../hooks';

const BaseLayout = ({ children }) => {
    const alertsWrapperRef = useRef(null)

    const [alertsHeight, setAlertsHeight] = useState(0)

    const handleAlertsResize = useCallback((alertsDomReact) => {
        setAlertsHeight(alertsDomReact.height)
    }, []);

    useResizeObserver(alertsWrapperRef.current, handleAlertsResize);

    return (
        <div className="base-layout-wrapper">
            <SideMenu />
            <AlertContextWithProvider ref={alertsWrapperRef}>
                <div className='page-content' style={{ '--alerts-height': `${alertsHeight}px` }}>
                    {children}
                </div>
            </AlertContextWithProvider>
        </div>
    )
}



export default BaseLayout
